/**
 * Create fine tuned Ajax request.
 *
 * @module request
 *
 * @author Stanislav Kalashnik <sk@infomir.eu>
 * @author Yaroslav Surilov <y.surilov@infomir.com>
 */

'use strict';

/**
 * Ajax request.
 *
 * @param {string} method - "post", "get" or "head"
 * @param {string} url - URL address
 * @param {Function} callback - callback handler
 * @param {Object} [headers] - list of optional headers like "charset", "Content-Type" and so on
 * @param {string} [type=text] - data parsing mode: plain text (default), xml, json
 * @param {boolean} [async=true] - send asynchronous request
 *
 * @return {XMLHttpRequest} request object in case response headers are necessary
 *
 * @example
 * request(
 *     'get',
 *     'https://google.com/',
 *     function ( data, status ) {
 *         console.info(data, status);
 *     },
 *     {
 *         charset:'utf-8'
 *     }
 * );
 */
module.exports = function ( method, url, callback, headers, type, async ) {
    var jdata   = null,
        timeout = null,
        xhr     = new XMLHttpRequest(),
        title   = 'AJAX ' + method.toUpperCase() + ' ' + url,
        hname;

    async = async !== false;
    xhr.onreadystatechange = function () {
        if ( xhr.readyState === 4 ) {
            clearTimeout(timeout);
            console.log('status:' + xhr.status + ', length:' + xhr.responseText.length, title);
            //console.log(xhr.responseText, title);
            if ( type === 'json' && xhr.status === 200 ) {
                try {
                    jdata = JSON.parse(xhr.responseText);
                } catch ( ex ) {
                    console.log('error AJAX JSON.parse');
                    jdata = null;
                }
            }
            if ( typeof callback === 'function' ) {
                callback(type === 'xml' ? xhr.responseXML : (type === 'json' ? jdata : xhr.responseText), xhr.status, xhr); // eslint-disable-line
            }
        }
    };
    xhr.open(method, url, async);
    // set headers if present
    if ( headers ) {
        for ( hname in headers ) {
            if ( headers.hasOwnProperty(hname) ) {
                xhr.setRequestHeader(hname, headers[hname]);
            }
        }
    }
    xhr.send();
    console.log('sent', title);
    // abort after some time (60s)
    timeout = setTimeout(function () {
        xhr.abort();
        console.log('ABORT on timeout', title);
        if ( typeof callback === 'function' ) {
            callback(null, 0);
        }
    }, 60000);

    return xhr;
};
